<div class="verification-container" style="align-items: center;">
  <div *ngIf="!paymentExists" style="text-align: center;">
    <div *ngIf="dataLoading" class="loader-inner ball-triangle-path" style="z-index: 1000;top: 150px; margin-left: 50%;">
      <div [style.border-color]="boxMainColor"></div>
      <div [style.border-color]="boxMainColor"></div>
      <div [style.border-color]="boxMainColor"></div>
    </div>

    <label>Enter Verification Code</label>
    <div class="verification-code">
      <div class="code-box" *ngFor="let i of [0,1,2,3,4,5]" [class.active]="inputedCode.length === i">
        {{ inputedCode[i] || '' }}
      </div>

      <input #verificationInput type="text" maxlength="6" minlength="6" pattern="[A-Za-z0-9]{6}"
        [(ngModel)]="inputedCode" (ngModelChange)="onCodeChange($event)" (paste)="onPaste($event)" class="hidden-input">
    </div>

    <div *ngIf="allowedMethods.length >= 1" class="mb-3">
      <label class="form-label fw-bold d-block">Payment Method</label>

      <div class="d-inline-block text-start">
        <div *ngFor="let method of allowedMethods" class="form-check">
          <input class="form-check-input" type="radio" name="paymentMethod" [id]="method" [value]="method"
            [(ngModel)]="selectedMethod">

          <label class="form-check-label" [for]="method">
            {{ method }}
          </label>
        </div>
      </div>
    </div>

    <button class="btn btn-primary mt-3" (click)="getInvoiceSiteData()">
      Start Payment Process
    </button>
  </div>
  <!-- Only for Forte Payments -->
  <div
    *ngIf="(paymentRecord.paymentPending || processingForteRequest) && siteRecord.paymentSystem == 2 && paymentExists"
    class="fortePaymentModal" [ngClass]="{'darkMode': darkMode}"
    style="min-width: 750px; min-height: 475px; padding: 0.5em; ">
    <h3 *ngIf="paymentRecord.externalACHPayment">{{ paymentRecord.achSettlementStatus === 0 ? 'Complete ACH Payment' :
      'ACH Payment Pending'}}</h3>
    <h3 *ngIf="!paymentRecord.externalACHPayment" #completeCardPaymentHeader>Complete CARD Payment</h3>

    <button type="button" class="btn-close" aria-label="Close" *ngIf="!isSaving && !processingForteRequest"
      style="position: absolute; top: 0.5em; right: 0.5em;" (click)="closePaneEmitter.emit()">
    </button>

    <div class="card-forte-details" *ngIf="paymentRecord.cardAmount > 0 || paymentRecord.externalACHPayment">
      <p>You are creating Payment Reference #{{paymentRecord.paymentNumber}} for Invoice #{{invoiceRecord.invoiceNumber}} </p>
      <p *ngIf="paymentRecord.achSettlementStatus === 0">This payment is pending and has not been processed. Click
        <strong>Pay</strong> to complete the payment.
      </p>
      <p *ngIf="paymentRecord.achSettlementStatus === 1">This ACH transaction has been started and is currently awaiting
        clearance.</p>

      <div class="d-flex justify-content-center mt-2 mb-2" *ngIf="forteSessionExpired || processingForteRequest">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <!-- ACH -->
      <div *ngIf="paymentRecord.externalACHPayment" class="payment-details mb-3 mt-2 p-3">
        <dl class="row mb-0 small">
          <dt class="col-3 text-start fw-semibold pt-1" *ngIf="paymentRecord.externalPaymentId">TransactionID</dt>
          <dd class="col-9 text-end fw-semibold pt-1 mb-1" *ngIf="paymentRecord.externalPaymentId">
            {{paymentRecord.externalPaymentId}}</dd>
          <!--TODO:bump up font size-->
          <dt class="col-7 text-start text-muted fw-normal"><h3>Total</h3></dt>
          <dd class="col-5 text-end mb-1"><h3>{{paymentRecord.achAmount | currency}}</h3></dd>

          <dt class="col-7 text-start text-muted fw-normal" *ngIf="paymentRecord.achSurchargeAmount">
            {{paymentRecord.achSurchargePercentage? (paymentRecord.achSurchargePercentage / 100 | percent:'1.2-2') :
            ''}} ACH Surcharge</dt>
          <dd class="col-5 text-end mb-1" *ngIf="paymentRecord.achSurchargeAmount">{{paymentRecord.achSurchargeAmount |
            currency}}</dd>

          <dt class="col-7 text-start text-muted fw-normal" *ngIf="paymentRecord.achTaxAmount">
            {{paymentRecord.achSurchargeTaxRate / 100 | percent:'1.2-2'}} ACH Surcharge Tax</dt>
          <dd class="col-5 text-end mb-1" *ngIf="paymentRecord.achTaxAmount">{{paymentRecord.achTaxAmount | currency}}
          </dd>
          <!--//TODO: font size-->
          <dt class="col-7 text-start fw-semibold border-top pt-1 mt-1"><h3>Payment Total</h3></dt>
          <dd class="col-5 text-end fw-semibold border-top pt-1 mb-0 mt-1"><h3>{{(paymentRecord.achAmount +
            paymentRecord.achSurchargeAmount + paymentRecord.achTaxAmount) | currency}}</h3></dd>
        </dl>
      </div>

      <!-- Card -->
      <div *ngIf="!paymentRecord.externalACHPayment" class="payment-details mb-3 mt-2 p-3">
        <dl class="row mb-0 small">
          <dt class="col-7 text-start text-muted fw-normal"><h3>Total</h3></dt>
          <dd class="col-5 text-end mb-1"><h3>{{paymentRecord.cardAmount | currency}}</h3></dd>

          <dt class="col-7 text-start text-muted fw-normal" *ngIf="paymentRecord.cardSurchargeAmount">
            {{paymentRecord.cardSurchargePercentage / 100 | percent:'1.2-2'}} Card Surcharge</dt>
          <dd class="col-5 text-end mb-1" *ngIf="paymentRecord.cardSurchargeAmount">{{paymentRecord.cardSurchargeAmount
            | currency}}</dd>

          <dt class="col-7 text-start text-muted fw-normal" *ngIf="paymentRecord.addedTaxAmount">
            {{paymentRecord.cardSurchargeTaxRate / 100 | percent:'1.2-2'}} Card Surcharge Tax</dt>
          <dd class="col-5 text-end mb-1" *ngIf="paymentRecord.addedTaxAmount">{{paymentRecord.addedTaxAmount |
            currency}}</dd>

          <dt class="col-7 text-start fw-semibold border-top pt-1 mt-1"><h3>Payment Total</h3></dt>
          <dd class="col-5 text-end fw-semibold border-top pt-1 mb-0 mt-1"><h3>{{(paymentRecord.cardAmount +
            paymentRecord.cardSurchargeAmount + paymentRecord.addedTaxAmount) | currency}}</h3></dd>
        </dl>
      </div>

      <ng-container *ngIf="forteError">
        <div *ngIf="savingErrorRetryCount < 3" class="alert" [ngClass]="forteError ? 'alert-danger' : 'alert-warning'"
          role="alert">
          <strong>{{ forteError ? 'Error' : 'Warning' }}:</strong> {{ forteErrorMessage }}
          <div *ngIf="savingErrorRetryCount > 0" class="mt-1 small text-muted">
            Save attempt {{ savingErrorRetryCount }} of 3...
          </div>
        </div>

        <div *ngIf="savingErrorRetryCount >= 3" class="alert alert-danger" role="alert">
          <strong>Save Failed After Multiple Attempts</strong>
          <p class="mt-2 mb-1">
            The payment was processed successfully, but the record could not be saved after 3 attempts.
            <strong>This Payment record will need to be manually updated by the Stellar team.</strong>
          </p>
          <hr />
          <p class="mb-1"><strong>Next Steps:</strong></p>
          <ul class="mb-2">
            <li>Contact <strong>Stellar Support</strong> at <strong>(307) 234-3997</strong> - this invoice and payment
              record will need to be manually updated by the Stellar team.</li>
            <li>A file has been automatically downloaded to your machine. Please provide this file to <strong>Stellar
                Support</strong> for the quickest resolution.</li>
          </ul>

          <p class="mb-0 small text-muted">Transaction ID: {{ paymentRecord.externalPaymentId }}</p>
        </div>
      </ng-container>

      <div *ngIf="paymentRecord.achSettlementStatus === 1 && !processingForteRequest" class="alert alert-info"
        role="alert">
        <strong>Info:</strong> This ACH transaction has been started and is currently awaiting processor approval. ACH
        Payments typically take 2-4 business days to process.
      </div>

      <div *ngIf="paymentRecord.achSettlementStatus !== 1 && !processingForteRequest">
        <!-- session expiry countdown -->
        <div *ngIf="forteCountdownDisplay" class="forte-session-timer mb-2"
          [ngClass]="{'text-danger': forteSessionNearExpiry, 'text-muted': !forteSessionNearExpiry}">
          <small>Session expires in: <strong>{{ forteCountdownDisplay }}</strong></small>
        </div>

        <div class="forte-modal-options mb-3">
          <button class="btn btn-primary me-2" [disabled]="forteSessionExpired || processingForteRequest"
            (click)="forteCheckoutButtonRef.nativeElement.click(); processingForteRequest = true">
            Pay
          </button>

          <button *ngIf="forteSessionNearExpiry && !forteSessionExpired" class="ms-2 btn btn-outline-secondary"
            [disabled]="processingForteRequest"
            (click)="generateForteCheckoutButtonSignature(); processingForteRequest = false;">
            Refresh Session
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="paymentComplete">
    <div class="alert alert-success" role="alert">
      <h4 class="alert-heading">Payment Complete</h4>
      <p>Your payment has been successfully processed. Thank you!</p>
      <hr>
      <p class="mb-0">Transaction ID: {{ displayPaymentId }}</p>
    </div>
  </div>
  <div *ngIf="invoicePaid">
    <div class="alert alert-success" role="alert">
      <h4 class="alert-heading">Invoice Paid</h4>
      <p>Your invoice has already been successfully paid. Thank you!</p>
      <hr>
      <p>Please contact {{siteRecord.siteName}} for help.</p>
    </div>
  </div>
  <div *ngIf="recentACHFailure">
    <div class="alert alert-danger mt-2" role="alert" style="margin:auto; max-width: 65%; text-align: center;">
      <h5 class="alert-heading mb-2">
        <i class="fal fa-exclamation-triangle me-2"></i>This invoice's recent payment failed, please contact {{siteRecord.siteName}} for help.
        <p>{{siteRecord.invoiceRemittanceLine4}}</p>
      </h5>
    </div>
  </div>
</div>


<!-- Forte Checkout Button  (Hidden, clicked programmatically)-->
<button #forteCheckoutButton class="forte-checkout-button" type="button"
  style="position: absolute; left: -9999px;"></button>
